import {
  formatCheckoutPurchasedData,
  formatCompletedOrderData,
} from './functions';

export const userCheckoutPurchased = (orders, walletType) => {
  const data = formatCheckoutPurchasedData(orders);

  return {
    type: 'Checkout purchased',
    data: {
      ...data,
      wallet_type: walletType,
    },
  };
};

export const userCompletedOrder = orders => {
  const data = formatCompletedOrderData(orders);
  return {
    type: 'Order Completed',
    data,
  };
};

export const billingInformationCompleted = walletType => ({
  type: 'Billing Information Completed',
  data: {
    wallet_type: walletType,
  },
});
